<template>

	<div class="body-child">

        <Verification></Verification>

	</div>

</template>

<script lang="ts">
import { defineComponent } from "vue";
import Verification from "./Verification.vue";

export default defineComponent({
	name: "Test",

    components: {
        Verification
    },
});
</script>

<style lang="scss" scoped>

@import url("/public/src/css/default.scss");
@import url("/public/src/css/about.scss");

</style>